import React from 'react';

import { Fab } from '@mui/material';

import {
  LOAN_TERMS,
  LOAN_TERM_HEADER,
  DEFAULT_TAB_STYLE,
  SELECTED_TAB_STYLE,
} from '../../constants/Dashboard/Financing';

import './LoanTermTabs.css';

export const LoanTermTabs = ({
  handleLoanTermClick,
  selectedLoanTerms,
  financeLoanTerms = LOAN_TERMS,
}) => {
  return (
    <div className="loan-terms-wrapper">
      <p className="loan-term-header">{LOAN_TERM_HEADER}</p>
      <div className="loan-term-tabs-wrapper">
        {Object.keys(financeLoanTerms).map((loanTerm) => {
          const additionalStyling = selectedLoanTerms[loanTerm] ? SELECTED_TAB_STYLE : {};
          return (
            <Fab
              key={loanTerm}
              sx={{
                ...DEFAULT_TAB_STYLE,
                ...additionalStyling,
              }}
              variant="extended"
              size="large"
              onClick={() => handleLoanTermClick(loanTerm)}
            >
              {financeLoanTerms[loanTerm].text}
            </Fab>
          );
        })}
      </div>
    </div>
  );
};
